export default "__VITE_ASSET__D5rDnuK2__"